import BioAdmin from 'types/ba/bioAdmin';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationConstant: LtFramework.IAlertNotificationConstant = {
	alertNotificationId: 'alert-notification',
	alertNotificationPrefix: 'alert-notification-',
	alertNotificationSuccess: 'alert-success',
	alertNotificationInfo: 'alert-info',
	alertNotificationWarning: 'alert-warning',
	alertNotificationDanger: 'alert-danger',
	alertNotificationElementId: '.js-alert-notification',
};

export const AlertNotificationModuleConstant: LtFramework.IAlertNotificationModuleConstant = {
	action: {
		synchronize: 'synchronize',
		open: 'open',
		close: 'close',
	},
	getter: {
		getState: 'getState',
	},
	mutation: {
		setAlertNotifications: 'setAlertNotifications',
	},
	name: 'alertNotificationModule',
	state: {
		alertNotifications: 'alertNotifications',
	},
};

export const BioServicesConstant: LtFramework.IBioServicesConstant = {
	clubLeadString: 'Club Lead',
	personalTrainerString: 'Personal Trainer',
	rolesWithRates: ['Personal Trainer'],
	languagesName: 'languages',
	localDateFormat: 'MM/DD/YY hh:mm A z',
	specialtiesName: 'specialties',
	contentFragmentType: 'cf',
	contentFragmentResponsibilitiesTag: 'content-fragments:bios-admin/roles-responsibilities',
	textfieldRegexValidator: /^[a-zA-Z0-9 (\r\n|\r|\n)!@?#$%^&*()-=+;:{}|~<>\[\]\'`.,/\"\‘\’\“\”]*$/,
	spotifyPlaylistUrlRegex: /^(https:\/\/open.spotify.com\/(playlist|user)(\/|.*\/playlist\/))([a-zA-Z0-9]+)(.*)$/,
	instagramUrlRegex: /^(https:\/\/www.instagram.com\/.*)$/,
	facebookUrlRegex: /^(https:\/\/www.facebook.com\/.*)$/,
	twitterUrlRegex: /^(https:\/\/www.twitter.com\/.*)$/,
	youtubeUrlRegex: /^(https:\/\/www.youtube.com\/.*)$/,
	tiktokUrlRegex: /^(https:\/\/vm.tiktok.com\/.*)$/,
};

export const CookieConstant: LtFramework.ICookieConstant = {
	profileToken: 'ltf-profile',
	ssoId: 'LTFSSOIDCookie',
};

export const EventConstant: BioAdmin.IEventConstant = {
	EmployeeProfileServiceLoading: 'bio-employee-profile-service-loading',
	BioProfileServiceLoading: 'bio-profile-service-loading',
	BioRoleServiceLoading: 'bio-role-service-loading',
	BioSearchServiceLoading: 'bio-search-service-loading',
	TeamMemberListServiceLoading: 'bio-admin-team-member-list-service-loading',
};

export const EmployeeProfileModuleConstant: LtFramework.IEmployeeProfileModuleConstant = {
	action: {
		synchronize: 'synchronize',
	},
	getter: {
		getState: 'getState',
		getIsValid: 'getIsValid',
		getEmployeeId: 'getEmployeeId',
	},
	mutation: {
		setEmployeeProfile: 'setEmployeeProfile',
	},
	name: 'employeeProfileModule',
	state: {
		employeeProfile: 'employeeProfile',
	},
};

export const EmployeeStateConstant: LtFramework.IEmployeeStateConstant = {
	unknown: 'UNKNOWN',
	authenticated: 'AUTHENTICATED',
	unauthenticated: 'UNAUTHENTICATED',
};

export const BioProfileModuleConstant: BioAdmin.IBioProfileModuleConstant = {
	action: {
		getProfile: 'getProfile',
		modifyProfileClubs: 'modifyProfileClubs',
		removeProfileClub: 'removeProfileClub',
		updateAvatarId: 'updateAvatarId',
		updateQuote: 'updateQuote',
		updateQuoteCitation: 'updateQuoteCitation',
		updateAboutMe: 'updateAboutMe',
		modifyProfileLanguages: 'modifyProfileLanguages',
		removeProfileLanguage: 'removeProfileLanguage',
		updateProfileSocialLink: 'updateProfileSocialLink',
		modifyProfileServices: 'modifyProfileServices',
		removeProfileService: 'removeProfileService',
		modifyProfileSpecialties: 'modifyProfileSpecialties',
		removeProfileSpecialty: 'removeProfileSpecialty',
		modifySchedule: 'modifySchedule',
	},
	getter: {
		getState: 'getState',
		getIsValid: 'getIsValid',
		getClubs: 'getClubs',
		getAvatarId: 'getAvatarId',
		getPublishStatus: 'getPublishStatus',
		getPublicBioUrl: 'getPublicBioUrl',
		getBioProfilePaths: 'getBioProfilePaths',
		getPublishedProfile: 'getPublishedProfile',
		getTagGroup: 'getTagGroup',
		getServices: 'getServices',
		getSpecialties: 'getSpecialties',
		getLanguages: 'getLanguages',
		getSocialLinks: 'getSocialLinks',
		getSocialUrl: 'getSocialUrl',
		getCertifications: 'getCertifications',
		getQuote: 'getQuote',
		getQuoteCitation: 'getQuoteCitation',
		getAboutMe: 'getAboutMe',
		getSchedule: 'getSchedule',
		getVisibility: 'getVisibility',
		getPromoted: 'getPromoted',
		getDPTFlag: 'getDPTFlag',
		getJobTitles: 'getJobTitles',
		getBiosImages: 'getBiosImages',
	},
	mutation: {
		setProfile: 'setProfile',
		modifyProfileClubs: 'modifyProfileClubs',
		removeProfileClub: 'removeProfileClub',
		updateAvatarId: 'updateAvatarId',
		updateQuote: 'updateQuote',
		updateQuoteCitation: 'updateQuoteCitation',
		updateAboutMe: 'updateAboutMe',
		modifyProfileLanguages: 'modifyProfileLanguages',
		removeProfileLanguage: 'removeProfileLanguage',
		updateProfileSocialLink: 'updateProfileSocialLink',
		modifyProfileServices: 'modifyProfileServices',
		removeProfileService: 'removeProfileService',
		modifyProfileSpecialties: 'modifyProfileSpecialties',
		removeProfileSpecialty: 'removeProfileSpecialty',
		modifySchedule: 'modifySchedule',
	},
	name: 'bioProfileModule',
	state: {
		bioProfile: {} as BioAdmin.IBioProfile,
	},
};

export const UrlModuleConstant: LtFramework.IUrlModuleConstant = {
	action: {
		synchronize: 'synchronize',
	},
	mutation: {
		setUrl: 'setUrl',
	},
	getter: {
		getGlobalPageDriverUrl: 'getGlobalPageDriverUrl',
		getState: 'getState',
		getUrlParameter: 'getUrlParameter',
	},
	name: 'urlModule',
	state: {
		url: 'url',
	},
};

export const RoleConfigs = {
	'rolesFeatures': [
		{
			roleId: 1,
			roleName: 'Club Lead',
			features: [
				'contact',
				'phone',
				'locations',
				'responsibilities'
			]
		},
		{
			roleId: 2,
			roleName: 'Personal Trainer',
			features: [
				'contact',
				'certifications',
				'locations',
				'trainingCTAs',
				'services',
				'specialties',
				'socialMedia',
				'languages',
				'quote',
				'testimonials',
				'fullLayout',
				'schedule'
			]
		},
		{
			roleId: 3,
			roleName: 'Pilates Instructor',
			features: [
				'contact',
				'certifications',
				'locations',
				'classes',
				'socialMedia',
				'languages',
				'quote',
				'testimonials',
				'fullLayout'
			]
		},
		{
			roleId: 4,
			roleName: 'Studio Instructor',
			features: [
				'certifications',
				'locations',
				'classes',
				'spotify',
				'socialMedia',
				'languages',
				'quote',
				'testimonials',
				'fullLayout'
			],
		},
		{
			roleId: 5,
			roleName: 'Cycle Instructor',
			features: [
				'certifications',
				'locations',
				'classes',
				'spotify',
				'socialMedia',
				'languages',
				'quote',
				'testimonials',
				'fullLayout'
			]
		},
		{
			roleId: 6,
			roleName: 'Yoga Instructor',
			features: [
				'contact',
				'certifications',
				'locations',
				'classes',
				'spotify',
				'socialMedia',
				'languages',
				'quote',
				'testimonials',
				'fullLayout'
			]
		},
		{
			roleId: 7,
			roleName: 'Dynamic Personal Trainer',
			features: [
				'contact',
				'certifications',
				'locations',
				'classes',
				'spotify',
				'socialMedia',
				'languages',
				'quote',
				'testimonials',
				'fullLayout',
				'schedule'
			]
		}
	],
	'features': {
		'languages': {},
		'classes': {},
		'spotify': {},
		'services': {},
		'certifications': {},
		'socialMedia': {},
		'fullLayout': {},
		'testimonials': {},
		'specialties': {},
		'responsibilities': {},
		'quote': {
			'maxLength': '50'
		},
		'phone': {},
		'trainingCTAs': {},
		'contact': {},
		'schedules': {},
		'locations': {}
 	}
};

export const DPTConfig = {
    dptFlagClass: '.dpt-flag',
    imageName: 'dpt-portrait',
    biosAdmin: 'Bios Super User',
    roleName: 'Personal Trainer',
};
